import React from 'react';
import { IconButton } from '@mui/material';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { GenericMeetingEmailOverview } from '../../MeetingEmail/GenericMeetingEmailOverview';
import {
  IMeetingEmailTemplate,
  meetingEmailTemplateSchema,
} from '../../Interfaces/IMeetingEmailTemplate';
import { GenericMeetingEmailImport } from '../../MeetingEmail/GenericMeetingEmailImport';
import { useState } from 'react';

interface IProps {
  idLegalTransactionType: number;
  meetingEmailTemplateArray: IMeetingEmailTemplate[];
  setMeetingEmailTemplateArray: (arr: IMeetingEmailTemplate[]) => void;
}

export const MeetingEmailTemplateOverview: React.FC<IProps> = ({
  idLegalTransactionType,
  meetingEmailTemplateArray,
  setMeetingEmailTemplateArray,
}) => {
  const [isOpenImport, setIsOpenImport] = useState(false);

  // Speichern: wenn idMeetingEmailTemplate > 0, update, sonst neu hinzufügen
  const handleSave = (template: IMeetingEmailTemplate) => {
    if (template.idMeetingEmailTemplate > 0) {
      setMeetingEmailTemplateArray(
        meetingEmailTemplateArray.map(t =>
          t.idMeetingEmailTemplate === template.idMeetingEmailTemplate
            ? template
            : t
        )
      );
    } else {
      setMeetingEmailTemplateArray([...meetingEmailTemplateArray, template]);
    }
  };

  // Löschen: Eintrag aus dem Array entfernen
  const handleDelete = (template: IMeetingEmailTemplate) => {
    setMeetingEmailTemplateArray(
      meetingEmailTemplateArray.filter(
        t => t.idMeetingEmailTemplate !== template.idMeetingEmailTemplate
      )
    );
  };

  return (
    <>
      <GenericMeetingEmailOverview<IMeetingEmailTemplate>
        title='Termin-E-Mails'
        rows={meetingEmailTemplateArray}
        getId={item => item.idMeetingEmailTemplate}
        createEmpty={() => meetingEmailTemplateSchema.parse({})}
        onSave={handleSave}
        onDelete={handleDelete}
        headerActions={
          <IconButton color='primary' onClick={() => setIsOpenImport(true)}>
            <CopyAllIcon />
          </IconButton>
        }
      />

      {isOpenImport && (
        <GenericMeetingEmailImport
          open={isOpenImport}
          onClose={() => setIsOpenImport(false)}
          mode='template'
          idLegalTransactionType={idLegalTransactionType}
          existingTemplates={meetingEmailTemplateArray}
          onImportTemplates={templates =>
            setMeetingEmailTemplateArray([
              ...meetingEmailTemplateArray,
              ...templates,
            ])
          }
        />
      )}
    </>
  );
};
